import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Modal, Table, Input, message, Form } from 'antd';
import { http, addVisitLog, history } from 'libs';
import store from './store';

export default observer(function () {
  const [invoiceCode, setInvoiceCode] = useState();
  const [invoiceTitle, setInvoiceTitle] = useState();
  const [remarks, setRemarks] = useState();
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(false);

  useEffect(() => {
    setFetching(true);
    http.post(process.env.REACT_APP_CRM_API_URL+'outApi/invoice/listAll', {accountCode:store.record.organizationCode,maxResult:50})
      .then(res => {
        setInvoices(res.data.result);
        const invoice = res.data.result.find(x => x.is_default);
        if (invoice) {
          setInvoiceCode(invoice.code)
          setInvoiceTitle(invoice.name)
        }
      })
      .finally(() => setFetching(false))
  }, [])

  function handleSubmit() {
    if (!invoiceCode) return message.error('请选择发票信息');
    setLoading(true);
    // store.checkOrder({id:store.record.id,invoiceCode,invoiceTitle});
    const url = '/javaApi/front/quote/quoteCreateOrder';
    const params = {itemIdList: store.ids, invoiceCode,invoiceTitle, remarks}
    addVisitLog({
      pageName: '报价单下单',
      fromPageUrl: window.referrerUrl,
      pageUrl:`${window.location.origin}${history.location.pathname}`,
      eventCode: "OrderQuote",
      eventName: "报价单下单",
      content: JSON.stringify(params),
    })
    http.post(url, params)
      .then((res) => {
        message.success('下单成功');
        store.actionVisible = false;
        store.orderId = res;
        store.ids = [];
        store.quotePage = 1;
        store.quotePageSize = 10;
        store.quotePageTotal = 0;
        store.fetchQuoteRecords()
      }, () => setLoading(false))
  }

  return (
    <Modal
      visible
      width={600}
      maskClosable={false}
      title={`转为销售订单`}
      onCancel={() => store.actionVisible = false}
      confirmLoading={loading}
      onOk={handleSubmit}>
      <Form layout="vertical">
        <Form.Item label="订单备注：">
          <Input autoComplete="off" placeholder="请输入" value={remarks} onChange={e => setRemarks(e.target.value)}/>
        </Form.Item>
        <Form.Item required label="选择发票：">
          <Table
            rowKey="code"
            loading={fetching}
            dataSource={invoices}
            pagination={false}
            scroll={{ y: 600 }}
            onRow={(info) => ({
              onClick: () => {
                setInvoiceCode(info.code)
                setInvoiceTitle(info.name)
              }
            })}
            rowSelection={{
              type: 'radio',
              selectedRowKeys: [invoiceCode], 
              onChange: (keys, info) =>{
                setInvoiceCode(keys[0]);
                setInvoiceTitle(info[0].name);
              }}}>
            <Table.Column title="发票抬头" dataIndex="name"/>
            <Table.Column title="纳税登记号" dataIndex="identificationNumber"/>
          </Table>
        </Form.Item>
      </Form>
    </Modal>
  )
})